const cryptoObj = window.crypto || window.msCrypto; // IE11
// see comment from https://stackoverflow.com/a/36953272/1945578
export const range = (start, end) =>  [...Array(1 + end - start).keys()].map(v => start+v);

export const split = val => val.split( /,\s*/ );

export const extractLast = term => split(term).pop();

export const arrayUnique = items => [...new Set(items)]; // https://stackoverflow.com/a/33121880/1945578

export const arrayDifference = (array1, array2) => {
  let array2Set = new Set(array2);
  return array1.filter((item) => !array2Set.has(item));
}

// Like the <=> operator in other languages
export const triCompare = (a, b) => a === b ? 0 : (a > b ? 1 : -1);

export function randomHex(length) {
  let arrLength = Math.max(length / 4, 1),
    arr = new Uint32Array(arrLength);
  cryptoObj.getRandomValues(arr);
  return [...arr].map(v => v.toString(16)).join('').substring(0, length)
}

export function objectFilter(obj, fn) {
  return Object.fromEntries(
    Object.entries(obj).filter(fn)
  )
}

export function objectMap(obj, fn) {
  return Object.entries(obj).map(([k,v]) => fn(v,k))
}

export function objectForEach(obj, fn) {
  Object.entries(obj).forEach( ([k,v]) => fn(v,k))
}

export function objectSwap(obj) {
  return Object.fromEntries(objectMap(obj, (v,k) => [v,k]))
}

export function isEmptyObject(obj) {
  return !Object.keys(obj)?.length
}

export function firstChar(str, transform='uppercase'){
  return transform == 'uppercase' ? str.charAt(0).toUpperCase() : str.charAt(0).toLowerCase();
}

export function capitalizeFirst(str){
 return firstChar(str) + str.slice(1)
}

export function humanize(str, transformFirst=true) {
  if (typeof str !== 'string') return str;
  let string =  str.toLowerCase().replace(/_+/g, ' ');
  string = (transformFirst ? capitalizeFirst(string) : string);
  return string;
}

export function titleize(str) {
  return str.toLowerCase().replace(/\b\w/g, function(char) {
    return char.toUpperCase();
  }).replace(/[-_]/g, ' ');
}

export function articleFor(str) {
  if (typeof str !== 'string' || str === '') {
    return '';
  }
  return ['a', 'e', 'i', 'o', 'u'].includes(str[0].toLowerCase()) ? 'an' : 'a';
}

export function sumArray(arr) {
  return arr.reduce(function(sum, i) { return sum + i; }, 0);
}

export const arrayWrap = (val) => {
  return [val].flat();
}

export function camelcaseToUnderscore(str) {
  return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
}

export function parameterize(str) {
  if (typeof str !== 'string') return str;
  return str.trim().toLowerCase().replace(/[^a-zA-Z0-9 -]/, "").replace(/\s/g, "-");
}

export function renderStarRating(rating) {
  let stars = '';
  for (let i = 0; i < Math.floor(rating); i++) {
    stars += '<i class="fas fa-star text-primary"></i>';
  }
  if (rating % 1 > 0) {
    stars += '<i class="fas fa-star-half-alt text-primary"></i>';
  }

  if (rating == 0) {
    stars += '<i class="far fa-star text-primary"></i>';
  }

  return `<span class='rating'>${stars}</span>`;
}

export function autoDownload(url, fileName) {
  fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
    .catch(error => {
      console.error('Error while downloading the file:', error);
    });
}

// THIS IS A/B conversion testing and should be removed once it is completed
// reference card: https://trello.com/c/grhtIuzx
export function phoneVerificationConversionTracking() {
  window.Parsley.on('form:submit', function () {
    if (!$(this.element).hasClass('lead-form')) { return }; // we only care for lead submission forms

    if (!$(this.element).attr('action').includes('maybe_confirm_phone')) { // at max we can receive form:submit twice, first time for lead creation, second - after phone confirmation, we only want the first case to trigger this
      window._vis_opt_queue = window._vis_opt_queue || [];
      window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(200);});
    }
  });
}

export function compareArrays(a1, a2) {
  return a1.toString() === a2.toString();
}

export function isAbsoluteURL(urlString) {
  return urlString.startsWith('http://') || urlString.startsWith('https://') || urlString.startsWith('//');
}

export function exportCsv(rows, headers=null, filename="data-csv.csv") {
  const csvContent = headers ? [headers.join(','), ...rows].join('\n') : rows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement("a");
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

// Color conversion functions
export function hexToRgba(hex, alpha) {
  if (!hex) return hex;
  if (typeof hex !== 'string') {
    throw new TypeError('Invalid hex color format');
  }

  const { color, alpha: parsedAlpha } = parsedHexWithAlpha(hex); // color === '#RRGGBB'
  const r = parseInt(color.substring(1, 3), 16);
  const g = parseInt(color.substring(3, 5), 16);
  const b = parseInt(color.substring(5, 7), 16);

  const finalAlpha = typeof +alpha === 'number' ? alpha : parsedAlpha;
  return `rgba(${r}, ${g}, ${b}, ${finalAlpha})`;
}

export function rgbaToHex(rgba) {
  try {
    const [r, g, b, a] = rgba.match(/\d+(?:\.\d+)?/g).map(Number);

    const alphaHex = !a || a === 1 ? '' : Math.round(a * 255).toString(16).padStart(2, '0');
    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}${alphaHex}`;
  } catch (e) {
    throw new TypeError('Invalid rgba color format');
  }
}

// Parsed hex with alpha: normalize once and return base color and alpha
// Supports #RGB, #RRGGBB, #RGBA, #RRGGBBAA
// Returns { color: '#RRGGBB' | original non-string, alpha: number in [0,1] }
export function parsedHexWithAlpha(hex) {
  if (!hex || typeof hex !== 'string') return { color: hex, alpha: 1 };
  const normalized = fullHexFromShorthand(hex).replace(/^#/, '');
  const color = `#${normalized.substring(0, 6)}`;
  const alpha = normalized.length >= 8 ? parseInt(normalized.substring(6, 8), 16) / 255 : 1;
  return { color, alpha };
}

export function alphaFromHex(hex) {
  return parsedHexWithAlpha(hex).alpha;
}

export function hexWithAlpha(hex, alpha) {
  if (!hex || typeof hex !== 'string') return hex;

  const { color, alpha: parsedAlpha } = parsedHexWithAlpha(hex); // '#RRGGBB' + parsed alpha
  const a = typeof +alpha === 'number' ? alpha : parsedAlpha;     // precedence: explicit > parsed
  const clamped = Math.max(0, Math.min(1, a));
  const alphaHex = clamped === 1 ? '' : Math.round(clamped * 255).toString(16).padStart(2, '0');
  return `${color}${alphaHex}`;
}

export function rgbToRgba(rgb, alpha = 1.0) {
  return hexToRgba(rgbaToHex(rgb), alpha);
}

export function hexWithoutAlpha(hex) {
  return parsedHexWithAlpha(hex).color;
}

export function fullHexFromShorthand(hex) {
  let h = hex.replace(/^#/, '');
  if (h.length === 3 || h.length === 4) {
    // #RGB -> #RRGGBB, #RGBA -> #RRGGBBAA
    h = Array.from(h).flatMap(c => c.repeat(2)).join('');
  }
  return `#${h}`;
}